export const PICKUP = 'pickUp';
export const DROPBOX = 'dropBox';
export const SHOP_ONLINE = 'shopOnline';
export const DELIVERY = 'delivery';

export const MAX_ADDITIONAL_DETAILS_BYTES = 210;
export const MAX_SPECIAL_INSTRUCTIONS_BYTES = 210;
export const MAX_ORDERED_BY_BYTES = 40;
export const MAX_FIRST_NAME_BYTES = 20;
export const MAX_LAST_NAME_BYTES = MAX_FIRST_NAME_BYTES;
export const MAX_CONTACT_EMAIL_BYTES = 50;
export const MAX_CONTACT_PHONE_BYTES = 16;
export const MICO_VALUE = '1';
export const GUESS_USER = 'g';
export const REGISTER_USER = 'r';

export const MICO = 'Mico';
export const LOGGED = 'Logged';
export const GUEST = 'Guest';

export const CLIENT_TIME_FORMAT = 'EEE MMM dd yyyy HH:mm:ss';
export const PICKUP_AND_DELIVERY = 'pickupAndDelivery';
export const SUMMARY_AND_PAYMENT = 'summaryAndPayment';
export const REQUEST_BY_DATE = 'requestByDate';
export const PICKUP_AND_DELIVERY_FORM_VALUES =
  'PICKUP_AND_DELIVERY_FORM_VALUES';
export const ABORT_ERROR_CODE = 'ERR_CANCELED';
export const WILL_RECALCULATE_REASON = 'recalculate';

export const CONTACT_INFORMATION_ERROR_FIELD_NAME = 'contactInformationError';
export const DELIVERY_ADDRESS_ERROR_FIELD_NAME = `${SHOP_ONLINE}.addressError`;
export const DBSSHIPTO = 'DBSSHIPTO';
export const IS_SUGGESTED_AVI_ADDRESS_SELECTED =
  'isSuggestedAVIdAddressSelected';

export const PICKUPANDDELIVERY_PAGE_TOP_ESPOT =
  'PICKUPANDDELIVERY_PAGE_TOP_ESPOT';
export const PICKUPANDDELIVERY_PAGE_BOTTOM_ESPOT =
  'PICKUPANDDELIVERY_PAGE_BOTTOM_ESPOT';
export const CATSAS_PICKUPANDDELIVERY_SHIPPINGMETHOD_GUEST_ESPOT =
  'CATSAS_PICKUPANDDELIVERY_SHIPPINGMETHOD_GUEST_ESPOT';

export const SHIPPING_METHOD_LEARN_MORE_ESPOT = 'ShippingMethodLearnMoreEspot';

export const DEALER_MARKETING_OPTIN_INFO_CLAUSE_espot =
  'DEALER_MARKETING_OPTIN_INFO_CLAUSE_espot';
export const DEALER_LOCAL_COMPLIANCE_Info_espot =
  'DEALER_LOCAL_COMPLIANCE_Info_espot';
export const DEALER_LOCAL_COMPLIANCE_Details_espot =
  'DEALER_LOCAL_COMPLIANCE_Details_espot';

export const Legal_cookie_privacy_espot1 = 'Legal_cookie_privacy_espot1';
export const TERMS_AND_CONDITIONS_espot = 'TERMS_AND_CONDITIONS_espot';
export const PRIVACY_POLICY_espot = 'PRIVACY_POLICY_espot';
export const ESTIMATED_PICKUP_DATE_TOOLTIP = 'ESTIMATED_PICKUP_DATE_TOOLTIP';

export const PUD_ESPOTS = {
  espotNames: [
    PICKUPANDDELIVERY_PAGE_TOP_ESPOT,
    PICKUPANDDELIVERY_PAGE_BOTTOM_ESPOT,
    CATSAS_PICKUPANDDELIVERY_SHIPPINGMETHOD_GUEST_ESPOT,
    SHIPPING_METHOD_LEARN_MORE_ESPOT,
    DEALER_MARKETING_OPTIN_INFO_CLAUSE_espot,
    DEALER_LOCAL_COMPLIANCE_Info_espot,
    DEALER_LOCAL_COMPLIANCE_Details_espot
  ].join(','),
  top: PICKUPANDDELIVERY_PAGE_TOP_ESPOT,
  bottom: PICKUPANDDELIVERY_PAGE_BOTTOM_ESPOT,
  guess: CATSAS_PICKUPANDDELIVERY_SHIPPINGMETHOD_GUEST_ESPOT,
  deliveryMethod: SHIPPING_METHOD_LEARN_MORE_ESPOT,
  marketingOptinClause: DEALER_MARKETING_OPTIN_INFO_CLAUSE_espot,
  dealerComplianceInfo: DEALER_LOCAL_COMPLIANCE_Info_espot,
  dealerComplianceDetails: DEALER_LOCAL_COMPLIANCE_Details_espot
};

export const PUD_TERMS_AND_CONDITIONS_ESPOTS = {
  espotNames: [
    Legal_cookie_privacy_espot1,
    TERMS_AND_CONDITIONS_espot,
    PRIVACY_POLICY_espot
  ].join(','),
  legalCookie: Legal_cookie_privacy_espot1,
  termsAndConditions: TERMS_AND_CONDITIONS_espot,
  privacyPolicy: PRIVACY_POLICY_espot
};

export const zeroShippingCostTranslationKey = {
  I: 'FREIGHT_CHARGE_TIME_INVOICE',
  F: 'CAT_DEALER_FREE_SHIPPING',
  C: 'CAT_DEALER_SHIPPING_TAX_COLLECT',
  M: 'CAT_DEALER_FREIGHT_MANAGED'
};

export const END_USER_CERTIFICATION = {
  NO: 'no',
  YES: 'yes'
};

export const UOM_MILES = 'mi';

export const RBD_PARTS_AVAILABILITY_ESPOT = 'RBD_PARTS_AVAILABILITY_ESPOT';
export const REQUEST_BY_DATE_PART_AVAILABILITY =
  'REQUEST_BY_DATE_PART_AVAILABILITY';
export const CONTACT_DEALER = '[CONTACT_DEALER]';
export const SHIPPING_CODE = 'ShippingCode';
export const RBD_VALUE = 'RBDValue';
export const AVAILABLE_MSG = 'AvailableMsg';
export const AVAILABLE_DATE = 'AvailableDate';

export const IS_RBD_UPDATED = 'isRBDateUpdated';

export const INVALID_CHARS_STR = `\\,/,<,>,[,],{,}`;
export const NEW_INVALID_CHARS_ORDER_BY = '!,@,#,$,%,^,&,*,+,`,~,;,(,)';
export const FORWARD_SLASH_CHAR_REGEX_ORDER_BY = /[/]/;
export const NEW_INVALID_CHARS_REGEX_ORDER_BY = /[!@#$%^&*+`~;)(]/;
export const NEW_INVALID_CHARS_EMAIL_PHONE = '<,>,&,),(,;';
export const NEW_INVALID_CHARS_REGEX_EMAIL_PHONE = /[<>&)(;]/;
export const NEW_INVALID_CHARS_SPECIAL_INSTRUCTIONS =
  '\\,/,<,>,[,],{,},&,),(,;';
export const NEW_INVALID_CHARS_REGEX_SPECIAL_INSTRUCTIONS =
  /[\\\\/<>[\]{}&)(;]/;
export const COMPANY_REGEX_BRAZIL = /^\d{2}\.\d{3}\.\d{3}\/\d{4}-\d{2}$/;
export const INDIVIDUAL_REGEX_BRAZIL = /^\d{3}\.\d{3}\.\d{3}-\d{2}$/;
export const TAX_ID_FORMAT_ERROR = 'TAX_ID_FORMAT_ERROR';
export const CNPJ_FORMAT_ERROR = 'CNPJ_FORMAT_ERROR';
export const CPF_FORMAT_ERROR = 'CPF_FORMAT_ERROR';
export const UNITED_STATES = 'United States';

export const DELIVERY_REQUEST_DATE = 'deliveryRequestByDate';
export const PICKUP_REQUEST_DATE = 'pickupRequestByDate';
export const GUEST_INFO_FORM_ID = 'guestInformationForm';
export const ADOBE_ID = 'abTestCart';
export const PCC_RELEASE_BLOCKS_GUEST_USER_INFO =
  'pcc-release-blocks-guest-user-info';

export const SALESFORCE_SUPPORTED_LOCALES = {
  en_US: 'en_US',
  es_MX: 'en_US',
  ar_EG: 'ar_SA',
  in_ID: 'id_ID',
  pt_BR: 'pt_BR',
  zh_CN: 'zh_CN',
  da_DK: 'en_US',
  fr_FR: 'fr_FR',
  de_DE: 'de_DE',
  ja_JP: 'ja_JP',
  ko_KR: 'ko_KR',
  nl_NL: 'nl_NL',
  nb_NO: 'en_US',
  pl_PL: 'pl_PL',
  ru_RU: 'ru_RU',
  sv_SE: 'sv_SE',
  tr_TR: 'tr_TR',
  cs_CZ: 'en_US',
  iw_IL: 'en_US',
  th_TH: 'en_US',
  zh_TW: 'zh_TW',
  it_IT: 'it_IT',
  ta_IN: 'en_US',
  hi_IN: 'en_US',
  bn_BD: 'en_US',
  vi_VN: 'en_US',
  el_GR: 'en_US',
  bg_BG: 'en_US',
  kn_IN: 'en_US',
  fi_FI: 'en_US',
  te_IN: 'en_US',
  uk_UA: 'en_US',
  ro_RO: 'en_US'
};
